import './App.css';
import React from "react";
import BeatsPerMinuteTable from "./BeatsPerMinuteTable";
import Container from "@mui/material/Container";

function App() {

    return (
        <div className="App">
            <header className="App-header">
                <Container maxWidth="md">
                    <BeatsPerMinuteTable />
                </Container>
            </header>
        </div>
    );
}

export default App;
